import HIDBaseRequest from '../HIDBaseRequest'

export default class NCCNRequest extends HIDBaseRequest {
  getLinkGuidelines (params, paging) {
    return this.post(`go/v1/nccn/map-to-guideline?page_num=${paging.page_num}&page_size=${paging.page_size}&sort=asc&sort_by=sort_order`, params)
  }
}
